export default __webpack_public_path__ + "images/8B.90361fc.png";